import React from 'react';
import {
  Box,
  Button,
  Center,
  Modal,
  ModalContent,
  ModalBody,
  ModalOverlay,
  Text,
  Heading,
} from '@chakra-ui/react';
import { bool, func } from 'prop-types';
import loadable from '@loadable/component';

import { useImaginationRoom } from '@invitato/imagination-room';

import useLang from '@/hooks/useLang';

import { THE_BRIDE } from '@/constants/index';
import { IMG_GALLERY_COVER } from '@/constants/assets';
import { BUTTON_PADDING_PROPS } from '@/constants/colors';
import { ASSETS_BG_PATTERN_2 } from '@/constants/assets';
import { TEXT_PROPS } from '@/constants/default-props';

import txt from './locales';
import { photos as photosCompassion } from './api/photos-2';

const LoadableGallerry = loadable(() =>
  import(/* webpackChunkName: "invitato-gallery-photos" */ './Gallery'),
);

function PhotoContent({ isOpen, onClose }) {
  const lang = useLang();
  const { onGetFinalContent, onGetFinalName } = useImaginationRoom();

  return (
    <Modal size="full" isOpen={isOpen} onClose={onClose} scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent maxW="500px">
        <ModalBody width="100%" padding="0" pos="relative" overflowY="scroll" overflowX="hidden">
          <Box
            bgImage={onGetFinalContent('IMG_GALLERY_COVER', IMG_GALLERY_COVER)}
            height="70vh"
            width="100%"
            bgSize="cover"
            bgPosition="center"
            pos="relative"
          >
            <Center
              width="100%"
              flexDir="column"
              pos="absolute"
              top="36px"
              left="50%"
              transform="translateX(-50%)"
            >
              <Text {...TEXT_PROPS.body} color="alternativeColorText" marginBottom="8px">
                The Wedding of
              </Text>
              <Heading
                {...TEXT_PROPS.subHeading}
                textAlign="center"
                color="alternativeColorText"
                fontWeight="bold"
                dangerouslySetInnerHTML={{
                  __html: onGetFinalName('coupleName', THE_BRIDE)
                }}
              />
            </Center>
          </Box>
          {/* Images Cover */}
          <Box
            bgImage={ASSETS_BG_PATTERN_2}
            bgSize="cover"
            bgPos="top center"
            bgRepeatY="repeat-y"
            bgRepeatX="no-repeat"
            padding="32px 32px 0 32px"
          >
            <Box textAlign="center" color="mainColorText">
              <Box paddingTop="42px">
                <Box>{isOpen && <LoadableGallerry data={photosCompassion} />}</Box>
              </Box>
            </Box>
            <Center margin="0 0 24px 0">
              <Button {...BUTTON_PADDING_PROPS} marginTop="32px" onClick={() => onClose()}>
                {txt.backContent[lang]}
              </Button>
            </Center>
            <Box height="80px" width="100%" background="transparent" />
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

PhotoContent.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired,
};

export default PhotoContent;
